import { Text } from 'pixi.js';
import type { Container } from 'pixi.js';
import { onLayoutPopulated } from '../populate';
import { CurvedText } from '../../../game/views/common/text/CurvedText';
import { hookUpPropsOfOther } from '../../../utils/pixi/hookUpPropsOfOther';

type TextWithCurvedData = Text & { data: { curveRadius: number } };

const curvedTextSymbol = Symbol('curvedTextInstance');

export function getCurvedTextInstanceFromText(textObj: Text): CurvedText | null {
  return (textObj as unknown as { [curvedTextSymbol]: CurvedText })[curvedTextSymbol] ?? null;
}

export function replaceWithCurvedText(textObj: Text, radius: number): CurvedText {
  const curvedText = new CurvedText({ text: textObj.text, textStyle: textObj.style, radius }).props({
    parent: textObj.parent,
    addAtIndex: textObj?.parent?.children?.indexOf(textObj),
  });

  if (textObj.anchorX !== 0.5 || textObj.anchorY !== 0.5) {
    console.warn('replaceWithCurvedText - issues with text with anchor other than 0.5');
  }

  hookUpPropsOfOther(curvedText, textObj);

  textObj.renderable = false;

  (textObj as unknown as { [curvedTextSymbol]: CurvedText })[curvedTextSymbol] = curvedText;

  return curvedText;
}

export function layoutCurvedTextSPL(): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: { root: Container; curvedText_SPL?: TextWithCurvedData[] }) => {
    if (!layout.curvedText_SPL) return;

    layout.curvedText_SPL.forEach((text) => {
      if (!((text as unknown) instanceof Text && typeof text?.data?.curveRadius === 'number')) return;
      replaceWithCurvedText(text, text.data.curveRadius);
    });
  });
}
